// The ONE place subscription-tier strings live on the web client.
// Every component that previously carried its own ['STARTER','PLUS',...]
// array imports from here instead, so tier logic can never drift per-file.
//
// Under the trial+subscriptions-only model:
//  - SELLABLE_TIERS are the only plans new checkouts may buy (Pro + Family).
//  - GRANDFATHERED_TIERS keep resolving as entitled but are never sold.
//  - COMP_TIERS are internal bypass accounts.

export const SELLABLE_TIERS = ["PLUS", "FAMILY"]; // "pro" checkout maps to PLUS

export const GRANDFATHERED_TIERS = ["STARTER", "UNLIMITED", "PRO", "PREMIUM"];

export const COMP_TIERS = ["EDDY", "PHILIP", "NIKHIL"];

export const PREMIUM_TIERS = [
  ...SELLABLE_TIERS,
  ...GRANDFATHERED_TIERS,
  ...COMP_TIERS,
];

export const TIER_DISPLAY_NAMES = {
  NONE: "Free",
  STARTER: "Starter",
  PLUS: "Pro",
  PRO: "Pro",
  PREMIUM: "Pro",
  FAMILY: "Family",
  UNLIMITED: "Max",
  EDDY: "Pixley Team",
  PHILIP: "Pixley Team",
  NIKHIL: "Pixley Team",
};

export function isPremiumTier(tier) {
  return PREMIUM_TIERS.includes((tier || "NONE").toUpperCase());
}

export function isGrandfatheredTier(tier) {
  const t = (tier || "").toUpperCase();
  return GRANDFATHERED_TIERS.includes(t) && !SELLABLE_TIERS.includes(t);
}

export function tierDisplayName(tier) {
  return TIER_DISPLAY_NAMES[(tier || "NONE").toUpperCase()] || "Free";
}
